import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import userService from '../services/userService';

const AdminLayout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'bg-indigo-800 border-b-4 border-blue-500' : 'hover:bg-blue-500';
  };

  const handleGoToDocs = async () => {
    if (!user) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
      const data = await userService.getUserToken();
      if (data.token) {
        //window.open(`${apiUrl}/docs`, '_blank');
        window.location.href = `${apiUrl}/docs`;
      } else {
        window.alert('No tienes token asignado para mirar la documentación.');
      }
    } catch (err) {
      window.alert('No tienes token asignado para mirar la documentación.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <nav className="bg-indigo-700 text-white">
        <div className="px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
          <div className="flex items-center gap-4">
            <span className="font-bold text-lg text-center sm:text-left">Panel de Administración</span>
            <button
              onClick={handleGoToDocs}
              className="bg-yellow-400 hover:bg-yellow-500 text-indigo-900 font-semibold px-3 py-1 rounded shadow transition-colors text-sm"
              title="Ir a la documentación Interlink"
            >
              Ir a Interlink
            </button>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 w-full sm:w-auto">
            <span className="font-medium text-sm sm:text-base">Usuario: {user?.nombre}</span>
            <button
              onClick={handleLogout}
              className="bg-red-500 hover:bg-red-700 px-4 py-1 rounded text-white font-semibold w-full sm:w-auto"
            >
              Salir
            </button>
          </div>
        </div>
        <div className="bg-indigo-800 px-2 sm:px-6 py-2 overflow-x-auto">
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 w-full">
            <Link
              to="/panel-administrador/generar-token"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors text-center ${isActive('/panel-administrador/generar-token')}`}
            >
              GENERAR TOKEN
            </Link>
            <Link
              to="/panel-administrador/ver-tokens"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors text-center ${isActive('/panel-administrador/ver-tokens')}`}
            >
              VER TOKENS
            </Link>
            <Link
              to="/panel-administrador/usuarios"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors text-center ${isActive('/panel-administrador/usuarios')}`}
            >
              GESTION DE USUARIOS
            </Link>
          </div>
        </div>
      </nav>
      <main className="flex-1 p-2 sm:p-6 w-full max-w-6xl mx-auto">{children}</main>
    </div>
  );
};

export default AdminLayout; 